import axios from 'axios'
axios.defaults.paramsSerializer = params => {
  let newParams = {}

  if (params.request) {
    newParams = params.request
  } else {
    newParams = { ...params }
  }

  if (newParams instanceof Object) {
    const clearParams = (obj) => {
      for (const property in obj) {
        const value = obj[property]

        const isEmptyArray = value instanceof Array && !value.length
        const isZero = value === 0
        const isFunction = value instanceof Function
        const isObject = value instanceof Object && !(value instanceof Array) && !(value instanceof Function)

        if (isEmptyArray || isFunction || (!isZero && !value))
          delete obj[property]
        else if (isObject)
          clearParams(obj[property])
      }
    }
    clearParams(newParams);
  }

  return new URLSearchParams(newParams)
}

import Vue from 'vue';
import App from './App.vue';
import core from '@bmp-vue/core';
import {api} from '@/utils/index.js';

Vue.config.productionTip = false;

var controllers = require.context('@/controllers', true, /\.js$/);

const paths = require('@/plugins/router/paths').default;
const theme = require('@/plugins/vuetify/theme').default;

Vue.use(core, {
    controllers,
    api,
    paths,
    theme,
    carregaEnums: false,
    mount: (options) => {
         new Vue({
          ...options,
          render: h => h(App)
        }).$mount('#app');
    }
});
